import React from 'react';
import { HoverableTooltip } from '@unisporkal/tooltip';
import cx from 'classnames';
import InfoTooltipIcon from '../../icons/InfoTooltip.svg?icon';
import styles from './InfoTooltip.module.scss';

interface InfoTooltipProps {
  placement?: string;
  content: string | object;
  trackViewed?: () => void;
  className?: string;
}

/**
 * @deprecated Use `{ InfoTooltip }` from `src/react/shared/molecules/InfoTooltip` instead.
 */
const InfoTooltip = ({
  placement = 'bottom',
  content,
  trackViewed = () => null,
  className = undefined,
}: InfoTooltipProps) => (
  <span
    className={cx(styles.tooltipParent, className)}
    data-describedby="info"
  >
    <HoverableTooltip
      placement={placement}
      trackViewed={trackViewed}
      trigger={<InfoTooltipIcon />}
    >
      {content}
    </HoverableTooltip>
  </span>
);

export default InfoTooltip;
